import { useCallback } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { withLanguage } from '../utils/languageUrl';

const useLocalizedPath = () => {
  const { currentLanguage } = useLanguage();

  return useCallback(
    (target) => withLanguage(target, currentLanguage),
    [currentLanguage]
  );
};

export default useLocalizedPath;
